// extracted by mini-css-extract-plugin
export default {"root":"BatchDetailsTableHeader_root__uI9qg","heading":"BatchDetailsTableHeader_heading__hr2iV"};